export default __webpack_public_path__ + "static/media/bg_01_hover.e77bb056.png";